import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-property-detail-number-edit',
  templateUrl: './property-detail-number-edit.component.html',
  styleUrls: ['./property-detail-number-edit.component.scss'],
})
export class PropertyDetailNumberEditComponent implements OnInit {
  @Input() label: string;
  @Input() key: string;
  @Input() edited: boolean;
  @Input() hasAirbnbListing: boolean;
  @Input() value: number;
  @Input() allowDecimals: boolean = false;

  @Output() updated: EventEmitter<number> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  decrement() {
    if (this.value > 0) {
      this.value = this.value - 1;
      this.updated.emit(this.value);
    }
  }

  handleInput(input: HTMLInputElement): void {
    if (!this.allowDecimals) {
      // Remove any decimal points and numbers after them
      const value = input.value.split('.')[0];
      if (value !== input.value) {
        input.value = value;
      }
    }
  }

  handleChange(value: string): void {
    let numValue = Number(value);

    if (!this.allowDecimals) {
      // Convert to integer
      numValue = Math.floor(numValue);
    }

    // Ensure it's within bounds
    numValue = Math.max(0, Math.min(99, numValue));

    this.value = numValue;
    this.updated.emit(this.value);
  }
}
